import $ from '@sv/jquery';
import sv from '@sv/core';
import '../../util/portletUtil';
import '../../vendor/svAutoComplete/index';
import '../../vendor/jquery-ui-position/jquery-ui-position';
import '../../vendor/pagination';

export const handleSearch = (selector) => {
  const updateSearchResult = ($portlets, query) => {
    if (!query) {
      return false;
    }

    const $form = $portlets.find('form');
    const url = $form.data('fnBaseUrl') + query;
    const targetId = $form.data('fnResultContainer');
    const $target = $(targetId);
    sv.PortletUtil.doGetWithFade($target, url, updatePaging);
  };

  const $portlets = $(`.${selector}`);

  if (
    window.location.hash.indexOf('#query/') > -1 &&
    window.location.hash.length > 7
  ) {
    const queryIndex = window.location.hash.indexOf('#query/') + 7;
    const bookmarkedSearch = window.location.hash.substring(queryIndex);
    const decodedBookmarkedSearch = decodeURIComponent(bookmarkedSearch);
    const $searchBox = $portlets.find('input[name=query]');
    $searchBox.val(decodedBookmarkedSearch);
    updateSearchResult($portlets, bookmarkedSearch);
  }

  const $autoCompletes = $portlets.find('[data-fn-use-auto-complete]');
  if ($autoCompletes.length) {
    const $searchBox = $autoCompletes.find('input[name=query]');
    const targetId = $searchBox.attr('aria-controls');
    $searchBox.attr('autocomplete', 'off');
    $searchBox.svAutoComplete({
      source: $autoCompletes.data('fnAutoCompleteUrl'),
      minLength: 2,
      delay: 200,
      selectedValueContainerId: targetId,
    });
  }

  $portlets.find('form').on('submit', (e) => {
    const $target = $(e.target);
    const encodedQry = encodeURIComponent(e.target.elements.query.value); // Ensure '+' chars is encoded (might be treated as space char otherwise)
    updateSearchResult($target.parent(), encodedQry);
    window.location.hash = '#query/' + encodedQry;
    $target.find('[type=submit]').trigger('focus');
    return false;
  });

  updatePaging(selector);
};

export const updatePaging = (selector) => {
  let $paging;
  if (typeof selector === 'string') {
    $paging = $(`.${selector} [data-fn-sv-paging]`);
  } else {
    $paging = selector.find('[data-fn-sv-paging]');
  }

  if ($paging.length) {
    $paging.pagination({
      hitCount: $paging.data('hitcount'),
      hitContainer: $paging.data('hitcontainer'),
      baseUrl: $paging.data('baseurl'),
      hitsPerPage: $paging.data('hitsperpage'),
      text: {
        prev: $paging.data('prevtext'),
        next: $paging.data('nexttext'),
        goToPage: $paging.data('gotopage'),
        paginationLabel: $paging.data('paginationlabel'),
        currentPage: $paging.data('currentpage'),
      },
    });
  }
};
